// src/features/legacy-reports/components/LegacyAccountReportView.tsx

import { Alert, Stack } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { LegacyReportSections } from './LegacyReportSections';
import { LegacyTotalsCards } from './LegacyTotalsCards';
import type { LegacyAccountReport } from '../types';

interface LegacyAccountReportViewProps {
  report: LegacyAccountReport | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  /**
   * Render the timeseries/geography/embed breakdown panels. The /subaccounts
   * aggregate returns totals only (the backend fills no per-dimension
   * breakdowns), so the Sub-Accounts tab passes false to omit those
   * always-empty sections.
   */
  showBreakdowns?: boolean;
}

/** Shared rendering for the Account and Sub-Accounts tabs (same response shape). */
export function LegacyAccountReportView({
  report,
  isLoading,
  isError,
  error,
  showBreakdowns = true,
}: LegacyAccountReportViewProps) {
  if (isError) {
    return (
      <Alert color="yellow" icon={<IconAlertTriangle size={16} />} title="Report failed to load">
        {error?.message ?? 'Please try again.'}
      </Alert>
    );
  }

  return (
    <Stack gap="md">
      <LegacyTotalsCards totals={report?.totals.totals ?? null} isLoading={isLoading} />
      {showBreakdowns && (
        <LegacyReportSections
          timeseriesReport={report?.timeseriesReport}
          geoCountryReport={report?.geoCountryReport}
          geoRegionReport={report?.geoRegionReport}
          geoCityReport={report?.geoCityReport}
          embedUrlReport={report?.embedUrlReport}
          isLoading={isLoading}
        />
      )}
    </Stack>
  );
}
